import { useCallback, useMemo } from "react"

import { useSelector } from "react-redux"

import Filters from "../../../../../Components/Filters"
import { EPS_FILTER_ICONS, getEmptyEpsFilters, hasActiveEpsFilters } from "../epsFilters"

import styles from "./EpsColumnFilters.module.less"

const EpsColumnFilters = ({ filtersMap, filters, onChange }) => {
  const isMobile = useSelector((state) => state.nav.isMobile)

  const visibleFilters = useMemo(
    () => Object.fromEntries(Object.keys(filtersMap).map((key) => [key, true])),
    [filtersMap]
  )

  const handleChangeFilter = useCallback(
    (changed) => onChange((prev) => ({ ...prev, ...changed })),
    [onChange]
  )

  const handleClearFilters = useCallback(
    () => onChange(getEmptyEpsFilters(filtersMap)),
    [onChange, filtersMap]
  )

  return (
    <div className={styles.bar} data-testid="eps-column-filters">
      <Filters
        withoutAdd
        visibleFilters={visibleFilters}
        filtersTypeMap={filtersMap}
        columnIconMap={EPS_FILTER_ICONS}
        filters={filters}
        onChangeFilter={handleChangeFilter}
        showClearBtn={hasActiveEpsFilters(filters)}
        onClearFilters={handleClearFilters}
        isMobile={isMobile}
      />
    </div>
  )
}

export default EpsColumnFilters
